import { render, staticRenderFns } from "./ValidationViewer.vue?vue&type=template&id=5bd63b42&"
import script from "./ValidationViewer.vue?vue&type=script&lang=js&"
export * from "./ValidationViewer.vue?vue&type=script&lang=js&"
import style0 from "./ValidationViewer.vue?vue&type=style&index=0&id=5bd63b42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports